export const apiName: string = 'tipos-orgaos';
export const orgaoTiposRoute: string = 'tipo-orgao';
export const orgaoTiposStorage: string = 'orgaotipos';
export const orgaoTiposModuleName: any = {plural: 'Tipos de órgãos', single: 'Tipo de órgão'};

export const orgaoTiposQuery: any =
  {
    "where":{
      "and":[
        {"ativo":true},
        {
          "or": [
            {"descricao":{"regexp":"/REPLACEHERE/i"}},
            {"codigoTCE":{"regexp":"/REPLACEHERE/i"}}
          ]
        }
      ]
    },
    "include":["estado"],
    "order":"codigoTCE"
  };



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgao-tipos/shared/data.service.ts
 **/